import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  List,
  Button,
  Icon,
  Tooltip,
  Progress,
  message,
  Popconfirm
} from "antd";
import { categories } from "../../../Evaluation/questions";
import { IconCharts, PrintCharts } from "./renderCharts";
import { textMap, reportDetails } from "./text";
import { calculateResponses } from "../../../../components/Charts/chartData";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { documentLogo } from "../../../../components/Results/documentLogo";

const IconText = ({ type, text, category }) => (
  <span>
    <Tooltip title={category}>
      <Icon type={type} style={{ marginRight: 8 }} />
      {text}
    </Tooltip>
  </span>
);

function ResultList(props) {
  const specificCategories = Object.keys(categories[props.type]);
  var currentPercent = 0
  var i = 0
  let cdata
  const pdf = new jsPDF();
  pdf.setFontSize(10);

  const [highlight, setHighLight] = useState(specificCategories[0]);
  const [itemId, setItemID] = useState("");
  const [itemPeer1Name, setItemPeer1Name] = useState("");
  const [itemPeer2Name, setItemPeer2Name] = useState("");
  const [itemPeer3Name, setItemPeer3Name] = useState("");
  const [datanew, setdatanew] = useState();

  if (highlight !== specificCategories[0]) {
    setHighLight(specificCategories[0]);
    setItemID("");
  }

  function returnEvaluationID(id) {
    var evaluation = props.chartData
      .map(element => {
        if (element.id === id) {
          return element;
        }

        return null;
      })
      .filter(item => !!item);

    return evaluation[0];
  }

  function mapResults(id, highlight) {
    props.chartData.forEach(element => {
      if (element.id === id) {
        cdata = Object.keys(element.groupedByCategory[highlight])
          .map(answer => {
            return {
              own: element.groupedByCategory[highlight][answer].value,
              key: element.groupedByCategory[highlight][answer].title,
              peer1: element.groupedByCategory[highlight][answer].peer1,
              peer2: element.groupedByCategory[highlight][answer].peer2,
              peer3: element.groupedByCategory[highlight][answer].peer3
            };
          })

          .filter(item => !!item);
      }
      setdatanew(cdata);
    });

    return cdata;
  }

  async function printRapport(qdata, id, peer1N, peer2N, peer3N, index) {
    await setHighLight(specificCategories[i]);
    await setItemPeer1Name(peer1N);
    await setItemPeer2Name(peer2N);
    await setItemPeer3Name(peer3N);
    await setItemID(id);

    await setTimeout(function() {
      printClick(
        mapResults(id, specificCategories[i]),
        id,
        peer1N,
        peer2N,
        peer3N,
        index
      );
    }, 1000);
  }

  const printClick = (qdata, id, peer1N, peer2N, peer3N) => {
    if (i === 0) {
      pdf.addImage(documentLogo, "PNG", 80, 50, 50, 50);
      pdf.setFontSize(35);

      let text = reportDetails[props.type].headline[props.language];
      pdf.text(
        reportDetails[props.type].headline["x"],
        reportDetails[props.type].headline["y"],
        pdf.splitTextToSize(text, 180)
      );

      pdf.setFontSize(10);
      text = "INSTITUTE OF LEADERSHIP DINAMICS";
      pdf.text(72, 285, pdf.splitTextToSize(text, 180));

      text = "https://leadershipdynamic.net";
      pdf.text(79, 290, pdf.splitTextToSize(text, 180));

      pdf.addPage("a4");
    }

    const input = document.getElementById(reportDetails[props.type].id);
    input.setAttribute("data", mapResults(id, specificCategories[i]));
    html2canvas(input).then(canvas => {
      const imgData = canvas.toDataURL("image/png");

      let text = specificCategories[i];
      pdf.text(10, 20, pdf.splitTextToSize(text, 180));

      let v = reportDetails[props.type].questionsPlace;
      mapResults(id, specificCategories[i]).forEach(element => {
        pdf.setFontStyle("bold");
        text = element.key;
        pdf.text(10, v, pdf.splitTextToSize(text, 180));
        pdf.setFontStyle("none");

        if (element.peer1) {
          text =
            props.language === "en"
              ? "Own: " + element.own + "   " + peer1N + ": " + element.peer1
              : "Egen: " + element.own + "   " + peer1N + ": " + element.peer1;

          if (element.peer2) {
            text =
              props.props === "en"
                ? "Own: " +
                  element.own +
                  "   " +
                  peer1N +
                  ": " +
                  element.peer1 +
                  "   " +
                  peer2N +
                  ": " +
                  element.peer2
                : "Egen: " +
                  element.own +
                  "   " +
                  peer1N +
                  ": " +
                  element.peer1 +
                  "   " +
                  peer2N +
                  ": " +
                  element.peer2;

            if (element.peer3) {
              text =
                props.language === "en"
                  ? "Own: " +
                    element.own +
                    "   " +
                    peer1N +
                    ": " +
                    element.peer1 +
                    "   " +
                    peer2N +
                    ": " +
                    element.peer2 +
                    "   " +
                    peer3N +
                    ": " +
                    element.peer3
                  : "Egen: " +
                    element.own +
                    "   " +
                    peer1N +
                    ": " +
                    element.peer1 +
                    "   " +
                    peer2N +
                    ": " +
                    element.peer2 +
                    "   " +
                    peer3N +
                    ": " +
                    element.peer3;
            }
          }
        } else {
          text =
            props.language === "en"
              ? "Own: " + element.own
              : "Egen: " + element.own;
        }

        pdf.text(10, (v += 10), pdf.splitTextToSize(text, 180));

        v += 10;
      });

      pdf.addImage(
        imgData,
        "png",
        reportDetails[props.type].image["x"],
        reportDetails[props.type].image["y"],
        reportDetails[props.type].image["w"],
        reportDetails[props.type].image["h"]
      );

      if (i !== specificCategories.length - 1) {
        i++;
        setHighLight(specificCategories[i]);

        currentPercent += reportDetails[props.type].percent;

        document.getElementById(
          "progress" + id
        ).innerHTML = `<div class="ant-progress-bg" style="width: ${currentPercent}%; height: 8px;">`;

        printRapport(
          mapResults(id, specificCategories[i]),
          id,
          peer1N,
          peer2N,
          peer3N
        );
        pdf.addPage("a4");
      } else {
        pdf.save("result.pdf");
        document.getElementById(
          "progress" + id
        ).innerHTML = `<div class="ant-progress-bg" style="width: 0%; height: 8px;">`;
      }
    });
  };

  async function PrintEvalu(id, peer1N, peer2N, peer3N) {
    await setItemID(id);
    await setItemPeer1Name(peer1N);
    await setItemPeer2Name(peer2N);
    await setItemPeer3Name(peer3N);

    await setTimeout(function() {
      switch (props.type) {
        case "profile":
          props.printPDFOwnTa(
            document.getElementById("printPie"),
            props.language,
            document.getElementById("printDrivers")
          );
          break;
        default:
          props.printPDFEvuAdmin(
            id,
            peer1N,
            document.getElementById("idskillchartPrint"),
            document.getElementById("printGap"),
            props.language
          );
      }
    }, 2000);
  }

  return (
    <div>
      <List
        itemLayout="vertical"
        size="large"
        pagination={{
          pageSize: 3
        }}
        dataSource={props.results}
        renderItem={(item, index) => (
          (
            <List.Item
              key={item.author.fullName}
              style={{ textAlign: "left" }}
              actions={[
                <IconText
                  type="user"
                  text={`${item.author.age} år`}
                  category="Alder"
                />,
                <IconText
                  type="book"
                  text={textMap.education[item.author.educationalLevel]}
                  category="Uddannelse"
                />,
                <IconText
                  type="solution"
                  text={textMap.leaderExp[item.author.leadershipExp]}
                  category="Leader erfaring"
                />,
                <IconText
                  type="message"
                  text={item.author.numberOfReferences}
                  category="Antal Referencer"
                />,

                <div>
                  {
                    <Progress
                      id={"progress" + item.id}
                      strokeColor={{
                        "0%": "#FFFF",
                        "100%": "#0eb89a"
                      }}
                      percent={0}
                    />
                  }
                  <row>
                    <Popconfirm
                      title={"Er du sikker på at du vil slette?"}
                      onConfirm={() => {
                        props.deleteAdminResult(item.id);
                        message.success("Evaluering er slettet", 5);
                      }}
                    >
                      <Button style={{ padding: "10px" }} size="small">
                        <IconText type="delete" text="Delete" />
                      </Button>
                    </Popconfirm>
                    <Button
                      style={{ padding: "10px" }}
                      size="small"
                      onClick={() =>
                        PrintEvalu(
                          item.id,
                          item.peer1Name,
                          item.peer2Name,
                          item.peer3Name
                        )
                      }
                    >
                      <IconText type="download" text="Print Evaluering" />
                    </Button>
                    <Button
                      style={{ padding: "10px" }}
                      size="small"
                      onClick={() =>
                        printRapport(
                          mapResults(item.id, highlight),
                          item.id,
                          item.peer1Name,
                          item.peer2Name,
                          item.peer3Name,
                          index
                        )
                      }
                    >
                      <IconText type="download" text="Print Rapport" />
                    </Button>
                  </row>
                </div>
              ]}
              extra={
                <Link
                  to={`/admin/${props.type ? props.type : "results"}/${
                    item.id
                  }`}
                >
                  <div
                    style={{
                      backgroundColor: "#333",
                      width: "150px",
                      color: "#fff"
                    }}
                  >
                    <IconCharts type={props.type} item={item} />
                  </div>
                </Link>
              }
            >
              <List.Item.Meta
                title={
                  <Link to={`/admin/results/${item.id}`}>
                    {item.author.fullName}
                  </Link>
                }
                description={
                  <div>
                    {item.author.email} <br />
                    {new Date(item.createTime).toLocaleDateString()} kl.{" "}
                    {new Date(item.createTime).toLocaleTimeString()}
                  </div>
                }
              />
              <div>Antal besvarelser: {calculateResponses(item)}/3</div>
            </List.Item>
          )
        )}
      />

      <div>
        {!!itemId && (
          <PrintCharts
            type={props.type}
            drivers={
              props.results.filter(x => x.id === itemId)[0]
                ? props.results.filter(x => x.id === itemId)[0].driver
                : {}
            }
            data={returnEvaluationID(itemId)}
            highlight={highlight}
            peer1Name={itemPeer1Name}
            peer2Name={itemPeer2Name}
            peer3Name={itemPeer3Name}
            language={props.language}
            mappedData={!datanew ? mapResults(itemId, highlight) : datanew}
          />
        )}
      </div>
    </div>
  );
}

export default withRouter(ResultList);



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultCollection/ResultsList/component.js